import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from 'react-bootstrap';
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import axios from "axios";

const currencyList = [
  {
    value: "cad",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/CAD.png"
          alt="CAD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        CAD - Canadian Dollar
      </div>
    ),
  },
  {
    value: "ngn",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/NGN.png"
          alt="NGN"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        NGN - Nigerian Naira
      </div>
    ),
  },
  {
    value: "usd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USD.png"
          alt="USD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USD - US Dollar
      </div>
    ),
  },
  {
    value: "usdt",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDT.png"
          alt="EUR"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDT - USD Tether
      </div>
    ),
  },
  {
    value: "usdc",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDC.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDC - USD Coin
      </div>
    ),
  },
];

const recipientCurrencyList = [
  {
    value: "cad",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/CAD.png"
          alt="CAD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        CAD - Canadian Dollar
      </div>
    ),
  },
  {
    value: "ngn",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/NGN.png"
          alt="NGN"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        NGN - Nigerian Naira
      </div>
    ),
  },
  {
    value: "usd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USD.png"
          alt="USD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USD - US Dollar
      </div>
    ),
  },
  {
    value: "usdt",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDT.png"
          alt="EUR"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDT - USD Tether
      </div>
    ),
  },
  {
    value: "usdc",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDC.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDC - USD Coin
      </div>
    ),
  },
  {
    value: "myr",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/MYR.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        MYR - Malaysian Ringgit
      </div>
    ),
  },
  {
    value: "inr",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/INR.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        INR - Indian Rupee
      </div>
    ),
  },
  {
    value: "vnd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/VND.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        VND - Vietnamese đồng
      </div>
    ),
  },
  {
    value: "sgd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/SGD.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        SGD - Singapore dollar
      </div>
    ),
  },
  {
    value: "aed",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/AED.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        AED - AE dirham
      </div>
    ),
  },
  {
    value: "cny",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/CNY.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        CNY - CN Yuan
      </div>
    ),
  },
  {
    value: "gbp",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/GBP.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        GBP - UK Pound Sterling
      </div>
    ),
  },
  {
    value: "eur",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/EUR.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        EUR - EU Euro
      </div>
    ),
  },
  {
    value: "bdt",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/BDT.png"
          alt="BDT"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        BDT - Bangladeshi Taka
      </div>
    ),
  },
];

const options2 = [
  {
    value: "Effortless Global Payments",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Effortless Global Payments
      </div>
    ),
  },
  {
    value: "Apply for Letter of Credit (LC)",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Apply for Letter of Credit (LC)
      </div>
    ),
  },
  {
    value: "Tuition Payments for Canada",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Tuition Payments for Canada
      </div>
    ),
  },
  {
    value: "Real Estate Investment Payments",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Real Estate Investment Payments
      </div>
    ),
  },
];

const EditUserRequestQuote = (props) => {
  const [, setLoader] = useState(false);
  const token = useSelector((state) => state.token);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm();
  const GetQuotationData = () => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/quotation/${props.quotationId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    }).then(res => {
      setValue("recipientAmount",res.data.quotation.recipientAmount);
      setValue("recipientCurrency", res.data.quotation.recipientCurrency);
      setValue("currency", res.data.quotation.currency);
      setValue("service", res.data.quotation.serviceType);
      setLoader(false);
    }).catch(err => {
      setLoader(false);
    });
  }
  
  useEffect(() => {
    if(!props.show) {
      return;
    }
    GetQuotationData();
  }, [props.quotationId]);

  const handleUpdateQuotation = (data) => {
    setLoader(true);
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}/quotation/${props.quotationId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data: JSON.stringify({
        serviceType: data.service?.value || data.service,
        recipientAmount: data.recipientAmount,
        currency: data.currency?.value || data.currency,
        recipientCurrency: data.recipientCurrency?.value || data.recipientCurrency
      }),
    }).then(res => {
      setLoader(false);
      toast(res.data.message || "Your quotation successfully updated", {
        theme: "light",
        type: "success",
        position: "top-right"
      })
      props.getData();
      return props.onHide();
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors?.[0]?.msg, {
          theme: "light",
          type: "error",
          position: "top-right"
        })
      } else {
        toast(err?.response?.data?.message || err.message || "Quotation edit was unsuccessful.", {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      }
    })
  }

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Request Here
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="service">
              <Form.Label>Service <span>*</span></Form.Label>
              <Controller
                name="service"
                control={control}
                rules={{
                  required: { message: "Service is require", value: true }
                }}
                render={({ field }) => {
                  const item = options2.find(options => {
                    const currencyName = field.value?.value || field.value;
                    return options.value == currencyName;
                  });
                  return (
                    <Select
                      {...field}
                      value={item}
                      options={options2}
                      placeholder="Select service"
                    />
                  )
                }} />
              {errors.service ? <p className="errMsg">{errors.service.message}</p> : null}
            </Form.Group>

            <Form.Group className="mb-3" controlId="currency">
              <Form.Label>Your currency <span>*</span></Form.Label>
              <Controller
                name="currency"
                control={control}
                rules={{
                  required: { message: "Currency is require", value: true }
                }}
                render={({ field }) => {
                  const item = currencyList.find(options => {
                    const currencyName = field.value?.value || field.value;
                    return options.value == currencyName;
                  });
                  return (
                    <Select
                      {...field}
                      value={item}
                      options={currencyList.filter(f => {
                        const currencyName = watch("recipientCurrency")?.value || watch("recipientCurrency");
                        return f.value !== currencyName;
                      })}
                      placeholder="Select your currency"
                    />
                  )
                }} />
              {errors.currency ? <p className="errMsg">{errors.currency.message}</p> : null}
            </Form.Group>

            <Form.Group className="mb-3" controlId="RecipientCurrency">
              <Form.Label>Recipient currency <span>*</span></Form.Label>
              <Controller
                name="recipientCurrency"
                control={control}
                rules={{
                  required: { message: "Recipient currency is require", value: true }
                }}
                render={({ field }) => {
                  const item = recipientCurrencyList.find(options => {
                    const currencyName = field.value?.value || field.value;
                    return options.value == currencyName;
                  });
                  return (
                    <Select
                      {...field}
                      value={item}
                      options={recipientCurrencyList.filter(f => {
                        const currencyName = watch('currency')?.value || watch('currency')
                        return f.value !== currencyName;
                      })}
                      placeholder="Select recipient currency"
                    />
                  )
                }} />
              {errors.recipientCurrency ? <p className="errMsg">{errors.recipientCurrency.message}</p> : null}
            </Form.Group>

            <Form.Group className="mb-3" controlId="RecipientAmount">
              <Form.Label>Recipient amount <span>*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter recipient amount"
                {...register("recipientAmount", {
                  required: { message: "Recipient amount is require", value: true },
                  pattern: { message: "Recipient amount is not valid", value: /^[0-9]*\.?[0-9]{0,2}$/ }
                })} />
              {errors.recipientAmount ? <p className="errMsg">{errors.recipientAmount.message}</p> : null}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSubmit(handleUpdateQuotation)} className="button yellow" variant="primary" type="button">
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default EditUserRequestQuote